import { render, staticRenderFns } from "./MessageItem.vue?vue&type=template&id=48b71b95&scoped=true&"
import script from "./MessageItem.vue?vue&type=script&lang=js&"
export * from "./MessageItem.vue?vue&type=script&lang=js&"
import style0 from "./MessageItem.vue?vue&type=style&index=0&id=48b71b95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b71b95",
  null
  
)

export default component.exports